import { render, staticRenderFns } from "./MessageSendIndex.vue?vue&type=template&id=3aa35178&scoped=true"
import script from "./MessageSendIndex.vue?vue&type=script&lang=js"
export * from "./MessageSendIndex.vue?vue&type=script&lang=js"
import style0 from "./MessageSendIndex.vue?vue&type=style&index=0&id=3aa35178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa35178",
  null
  
)

export default component.exports